<!--begin::Form-->
<form class="form w-100" [formGroup]="loginForm" novalidate="novalidate" id="kt_login_signin_form"
  (ngSubmit)="submit()">
  <!-- The lockup only below lg, where the ink panel that carries it is hidden.
       Above that the brand appeared twice — once here and once 200px to the
       left — saying the same thing two ways. -->
  <div class="d-lg-none text-center mb-8">
    <app-brand-logo size="md"></app-brand-logo>
  </div>

  <!-- The form's own heading. Naming the action is what the lockup was standing
       in for, and it does the job the lockup could not: it changes when the
       dialog does. -->
  <h3 class="auth-form__title">{{ "AUTH.SIGN_IN" | translate }}</h3>

  @if (hasError) {
  <div class="mb-lg-8 alert alert-danger p-3">
    <div class="alert-text font-weight-bold fs-7">
      {{ errorKey | translate }}
    </div>
  </div>
  }

  <div class="fv-row mb-8">
    <label class="form-label fs-6 fw-semibold text-gray-800 mb-1">
      {{ "AUTH.EMAIL" | translate }}</label>
    <input class="form-control bg-transparent" type="email" name="email" formControlName="email" autocomplete="off" />
    <!-- <input
      class="form-control bg-transparent"
      type="email"
      name="email"
      formControlName="email"
      autocomplete="off"
      [ngClass]="{
        'is-invalid': loginForm.controls['email'].invalid,
        'is-valid': loginForm.controls['email'].valid
      }"
    /> -->
    <!-- <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Email is required',
        control: loginForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'email',
        message: 'Email is invalid',
        control: loginForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minLength',
        message: 'Email should have at least 3 symbols',
        control: loginForm.controls['email']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Email should have maximum 360 symbols',
        control: loginForm.controls['email']
      }"
    ></ng-container> -->
  </div>

  <div class="fv-row mb-3">
    <label class="form-label fw-semibold text-gray-800 fs-6 mb-1">
      {{ "AUTH.PASSWORD" | translate }}</label>

    <input class="form-control bg-transparent" type="password" name="password" autocomplete="off"
      formControlName="password" />
    <!-- <input
      class="form-control bg-transparent"
      type="password"
      name="password"
      autocomplete="off"
      formControlName="password"
      [ngClass]="{
        'is-invalid': loginForm.controls['password'].invalid,
        'is-valid': loginForm.controls['password'].valid
      }"
    /> -->
    <!-- <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'required',
        message: 'Password is required',
        control: loginForm.controls['password']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'minlength',
        message: 'Password should have at least 3 symbols',
        control: loginForm.controls['password']
      }"
    ></ng-container>
    <ng-container
      [ngTemplateOutlet]="formError"
      [ngTemplateOutletContext]="{
        validation: 'maxLength',
        message: 'Password should have maximum 100 symbols',
        control: loginForm.controls['password']
      }"
    ></ng-container> -->
  </div>

  <div class="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8">
    <div></div>

    <a class="text-primary cursor-pointer text-hover-underline" data-testid="forgot-link"
      (click)="updateAuthState(AuthStates.FORGOT_PASSWORD)">
      {{ "AUTH.FORGOT_PASSWORD" | translate }}
    </a>
  </div>

  <!-- The one action this dialog exists for. It used to be a plain `.btn` at
       body size with a WHITE label on the sky gradient — about 2:1 — which read
       as a disabled bar sitting above two tonal buttons that looked more
       clickable than it did. -->
  <div class="d-grid mb-8">
    <button type="submit" id="kt_sign_in_submit" class="btn btn-primary btn-lg fw-bold fs-5"
      [disabled]="loginForm.invalid">
      @if (isLoading$ | async) {
      <span class="indicator-progress" [style.display]="'block'">
        {{ "AUTH.SIGN_INING" | translate }}...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
      } @if ((isLoading$ | async) === false) {
      <span class="indicator-label fw-bold">{{
        "AUTH.SIGN_IN" | translate
        }}</span>
      }
    </button>
  </div>

  @if (demo.enabled) {
  <div class="separator separator-content my-7">
    <span class="w-auto text-gray-500 fs-8">{{ "AUTH.OR" | translate }}</span>
  </div>
  <!-- Both roles, like the 2021 build offered. The parent screens — their
       child's report, the courses they bought, the seats they hand out — are a
       third of what there is to look at here, and behind a password nobody
       types they may as well not exist. -->
  <div class="mb-7">
    <p class="text-gray-500 fs-8 text-center mb-3">
      {{ "AUTH.DEMO_HINT" | translate }}
    </p>
    <div class="d-flex flex-column flex-sm-row gap-3">
      <button type="button" class="btn btn-light-primary flex-fill" data-testid="demo-login" (click)="loginAsDemo()">
        {{ "AUTH.DEMO_AS_STUDENT" | translate }}
      </button>
      <button type="button" class="btn btn-light flex-fill" data-testid="demo-login-parent"
        (click)="loginAsDemoParent()">
        {{ "AUTH.DEMO_AS_PARENT" | translate }}
      </button>
    </div>
  </div>
  }

  <div class="text-gray-600 text-center fw-semibold fs-7">
    {{ "AUTH.NOT_REGISTER" | translate }}

    <a class="text-primary cursor-pointer text-hover-underline fw-bold" data-testid="register-link"
      (click)="updateAuthState(AuthStates.REGISTER)">
      {{ "AUTH.SIGN_UP" | translate }}
    </a>
  </div>
</form>

<ng-template #formError let-control="control" let-message="message" let-validation="validation">
  @if (control.hasError(validation) && (control.dirty || control.touched)) {
  <div class="fv-plugins-message-container text-danger">
    <span role="alert">
      {{ message }}
    </span>
  </div>
  }
</ng-template>